import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faXTwitter,
  faTelegram,
  faWhatsapp
} from "@fortawesome/free-brands-svg-icons";

import defaultLogo from "../../../components/img/logo.webp";
import { getSeasonLogo } from "../../../components/season";

const logoPandin = getSeasonLogo(defaultLogo);

function HeaderIndex() {
  const { i18n, t } = useTranslation();
  var wordsItems = t("Home.Words", { returnObjects: true });
  var headerItems = t("Home.Header", { returnObjects: true });

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <div className="container-fluid d-flex align-items-center home-header">
      <div className="container">
        <div className="row row-gap-5">
          <div className="col-12 col-lg-6 first-section">
            <div className="first-child row-gap-5 d-flex flex-wrap align-items-end rounded-1 h-100">
              <div className="col-12 im-pandin">
                {headerItems["Hi, I'm Pandin, a Full Stack Web Developer"]}
              </div>
              <div className="col-12 col-sm-6 d-flex justify-content-center contact-me">
                <a
                  href="https://wa.me/5511963840038"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button"
                >
                  {wordsItems["Contact-me"]}
                  <div className="arrow">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </div>
                </a>
              </div>
              <div className="col-12 col-sm-6 d-flex justify-content-center gap-4 social-media">
                <Link to="https://t.me/pandin" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faTelegram} />
                </Link>
                <Link to="https://wa.me/5511963840038" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </Link>
                <Link to="https://linkedin.com/in/pandin" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faLinkedin} />
                </Link>
                <Link to="https://x.com/pandindev" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faXTwitter} />
                </Link>
                <Link to="mailto:pandin@pandin.dev" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faEnvelope} />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 second-section">
            <div className="row-gap-5 d-flex flex-wrap rounded-1">
              <div className="col-12 d-flex justify-content-center">
                <div className="rounded-circle my-circle">
                  <img src={logoPandin} alt="Logo Pandin" className="w-100" />
                  <div className="overlay-img"></div>
                </div>
              </div>
              <div className="col-12 text-center my-name">Marcus Vinicius</div>
            </div>
          </div>
        </div>
      </div>
      <div className="wave">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="shape-fill"
          ></path>
        </svg>
      </div>
    </div>
  );
}

export default HeaderIndex;
